import Select, { SelectProps } from "components/select";
interface IProps extends Omit<SelectProps, "options"> {
  select?: (option: string | any) => void;
}

export default function LodChlSelect({ isReset = false, select }: IProps) {
  return (
    <Select
      name={"lodChlCd"}
      options={locChlOption}
      isReset={isReset}
      onSelect={(option: any) => select && select(option?.code)}
    />
  );
}

const locChlOption = [
  {
    ko: "UB사이트",
    en: "UBS",
    code: "UBS",
    value: "UBS",
  },
];
